import AxiosClient from './clients/axios'

const resource = 'integrations/mobly/services/cs'

const find = (sessid) => AxiosClient.get(`${resource}/${sessid}/warnings`)

export {
  find
}
